// extracted by mini-css-extract-plugin
module.exports = {"root":"projects-grid-module--root--1-3Ho"};